export default function() {
    return {
        showConfirmationModal: false,
        showSuccessModal: false,
        password: null,
        errorMessage: null
    }
}
